/* import __COLOCATED_TEMPLATE__ from './unhandled-form-error.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { closeModal } from 'sh-www/utils/modal-controls';

class UnhandledFormErrorModalComponent extends Component {
  @service('error-tracker') errorTracker;

  get errorString() {
    return this.args.model.errorValues.join(', ');
  }

  get hasMultipleErrors() {
    return this.args.model.errorValues.length > 1;
  }

  get shownError() {
    const errorsWord = this.hasMultipleErrors
      ? 'errors'
      : 'error';

    return `${this.errorString}. Fix the ${errorsWord} and submit again.`;
  }

  @action
  closeModal() {
    closeModal(this);
  }

  @action
  unhandledErrorShown() {
    this.errorTracker.error(`Missing error handling for "${this.errorString}"`);
  }
}

export default UnhandledFormErrorModalComponent;
